import { u } from './utilities';

export const unit = 8;

export const textSizes = {
  small: {
    fontSize: 1.5,
    lineHeight: 1.5,
    letterSpacing: 'normal',
  },
  'body-sm': {
    fontSize: 1.5,
    lineHeight: 1.5,
    letterSpacing: 'normal',
  },
  medium: {
    fontSize: 1.75,
    lineHeight: 1.57,
    letterSpacing: 'normal',
  },
  'body-md': {
    fontSize: 1.75,
    lineHeight: 1.57,
    letterSpacing: 'normal',
  },
  large: {
    fontSize: 2.25,
    lineHeight: 1.44,
    letterSpacing: '-0.2px',
  },
  'body-lg': {
    fontSize: 2.25,
    lineHeight: 1.44,
    letterSpacing: '-0.2px',
  },
  xlarge: {
    fontSize: 3,
    lineHeight: 1.16,
    letterSpacing: '-0.2px',
  },
  'heading-sm': {
    fontSize: 3,
    lineHeight: 1.16,
    letterSpacing: '-0.2px',
  },
  xxlarge: {
    fontSize: 4,
    lineHeight: 1.125,
    letterSpacing: '-0.5px',
  },
  'heading-md': {
    fontSize: 4,
    lineHeight: 1.125,
    letterSpacing: '-0.5px',
  },
  xxxlarge: {
    fontSize: 6,
    lineHeight: 1.16,
    letterSpacing: '-1.2px',
  },
  'heading-lg': {
    fontSize: 6,
    lineHeight: 1.16,
    letterSpacing: '-1.2px',
  },
};
export type TextSize = keyof typeof textSizes;

export const fontWeights = {
  book: 400,
  regular: 400,
  medium: 500,
  bold: 653,
};

// NOTE(tatiana): For reasons unclear to me at this time,
// I do not know why I have to do this silliness but
// it's the only way I can get the correct version to show
// in the Lens doc only
export const fontSettings = {
  normal: `'normal'`,
  tnum: `'tnum'`,
};

export const radii = {
  none: u(0),
  50: u(0.5),
  100: u(1),
  medium: u(1),
  150: u(1.5),
  175: u(1.75),
  200: u(2),
  large: u(2),
  250: u(2.5),
  300: u(3),
  xlarge: u(3),
  round: u(999),
  full: u(999),
};

export const shadows = {
  small: `0 ${u(0.5)} ${u(1.25)} hsla(0, 0%, 0%, 0.05)`,
  medium: `0 ${u(0.5)} ${u(1.25)} hsla(0, 0%, 0%, 0.1)`,
  large: `0 ${u(0.75)} ${u(3)} hsla(0, 0%, 0%, 0.1)`,
};

export const spaces = {
  xsmall: 0.5,
  small: 1,
  medium: 2,
  large: 3,
  xlarge: 5,
  xxlarge: 8,
};
export type Space = keyof typeof spaces;

export const breakpoints = {
  xsmall: '31em',
  small: '48em',
  medium: '64em',
  large: '75em',
};
export type Breakpoint = keyof typeof breakpoints;

export const gradients = {
  'ai-primary':
    'conic-gradient(from 270deg, #0469FF 90deg, #BF63F3 180deg, #FFA900 270deg, #0065FF 360deg)',
  'ai-secondary':
    'radial-gradient(138.41% 100% at 100% 100%, #E9F2FE 0%, #FFF 100%)',
};
